import { jsx } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Box } from "../../Box/Box.mjs";
import { base, multiLine, lineLimit } from "./MaxLines.css.mjs";
const MaxLines = ({
  children,
  lines
}) => /* @__PURE__ */ jsx(
  Box,
  {
    component: "span",
    className: [base, lines > 1 ? multiLine : void 0],
    style: lines > 1 ? assignInlineVars({ [lineLimit]: String(lines) }) : void 0,
    children
  }
);
export {
  MaxLines
};
